// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"319eb8fc","285":"4f0ec881","807":"33990de0","910":"13df3319"}[chunkId] + ".chunk.js";
};